import React from "react";
import { STYLE_PREFIX } from "../const";
import "./style.less";
var Spin = function Spin(_ref) {
  var spinning = _ref.spinning,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "custom-spin")
  }, spinning && /*#__PURE__*/React.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "custom-spin_wrapper")
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spot first"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spot bottom third"
  })), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spot second"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spot bottom fourth"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "custom-spin_children")
  }, children));
};
export default Spin;